module.exports = __webpack_public_path__ + "static/media/wre2.png.6d54bcc0.jpg";